import { Authority } from 'platform/app/authority.constant';

export const TEASER = {
    name: 'Teaser',
    path: '/teaser',
    icon: 'dm-image',
    requiresAuthority: Authority.ROLE_TEASERS_VIEW_EDIT,
};
